<app-modal #modal [size]="ModalSize.Xl" [scrollable]="true" customClassName="document-viewer-modal">
  <div class="modal-header">
    <h5 class="modal-title">{{ fileName }}</h5>
    <button type="button" class="close" (click)="hide()">
      <i class="far fa-times"></i>
    </button>
  </div>

  <div class="modal-body document-viewer-body">
    <div *ngIf="isLoading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <ng-container *ngIf="!isLoading">
      <!-- PDF Viewer -->
      <object *ngIf="documentType === 'pdf' && documentUrl"
              [data]="documentUrl"
              type="application/pdf"
              class="document-frame"
              (load)="onDocumentLoad()">
        <p>Your browser does not support PDF viewing. <a [href]="documentUrl" target="_blank">Download the PDF</a> instead.</p>
      </object>

      <!-- Image Viewer -->
      <img *ngIf="documentType === 'image' && documentUrl"
           [src]="documentUrl"
           [alt]="fileName"
           class="document-image"
           (load)="onDocumentLoad()" />

      <!-- Unsupported Format -->
      <div *ngIf="documentType === 'unsupported'" class="unsupported-message">
        <i class="far fa-file fa-3x mb-3"></i>
        <p>Preview is not available for this file type.</p>
        <p class="text-muted">Supported formats: PDF, JPG, PNG, GIF, BMP, WEBP</p>
      </div>
    </ng-container>
  </div>

</app-modal>
